import React, { useEffect, useState } from "react";
import { 
    Box, 
    Button,
    Checkbox, 
    Flex, 
    Heading,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Stack,
    Text,
} from "@chakra-ui/react";
import { BsThreeDotsVertical } from "react-icons/bs";
import CustomCard from "../ui/card";

type Task = {
    id: string,
    title: string;
    isCompleted: boolean
}

export default function OverviewTasks({ width, className }: { width?: string, className?: string }) {
    const [tasks, setTasks] = useState<Task[]>([
        { id: '1', title: 'Create new task', isCompleted: false },
        { id: '2', title: 'Create new task', isCompleted: true },
        { id: '3', title: 'Create new task', isCompleted: false },
        { id: '4', title: 'Create new task', isCompleted: false },
    ]);
    const [completedTasksCount, setCompletedTasksCount] = useState<number>(0);

    useEffect(() => {
        const completedTasksLength = tasks.filter(t => t.isCompleted).length;        
        setCompletedTasksCount(completedTasksLength)
    }, [tasks])
    
    function handleChange (taskId: string, event: React.ChangeEvent<HTMLInputElement>) {
        if (!taskId) return;

        const checked = event.target.checked;

        const updatedTasks = tasks.map((t) => t.id === taskId ? { ...t, isCompleted: checked } : t);
        setTasks(updatedTasks);
    }

    return (
        <CustomCard
            width='100%'
            marginBottom='4'
            children={(
                <Box width='100%' marginRight='10px'>
                    <Flex justifyContent={'space-between'} alignItems='center' width='100%'>
                        <Heading as='h4' size='md'>
                            Tasks
                        </Heading>
                        <Menu matchWidth>
                            <MenuButton 
                                as={Button}
                                height='2.1rem' 
                                fontSize='sm'
                                bg='transparent'
                                _hover={{ bg: 'transparent' }}
                                _expanded={{ bg: 'transparent' }}
                                _focus={{ boxShadow: 'none', bg: 'transparent' }} 
                                leftIcon={<BsThreeDotsVertical />} 
                            />
                            <MenuList>
                                {['View all'].map((item: string, index: number) => (
                                    <MenuItem 
                                        key={index} 
                                        // onClick={() => onDownloadOptionSelect!(item)}
                                    >
                                        {item}
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </Menu>
                    </Flex>
                    <Box>
                        <Text fontSize='sm' color='gray.500'>{completedTasksCount} of {tasks.length} completed</Text>
                    </Box>
                    <Box>
                    <Stack spacing={2} direction='column' marginTop={4}>
                        {tasks.map((t, index) => (
                            <Checkbox key={t.id} colorScheme='blue' isChecked={t.isCompleted} onChange={(e) => handleChange(t.id, e)}>
                                <span 
                                    style={{ 
                                        textDecoration: t.isCompleted ? 'line-through' : '',
                                        color: t.isCompleted ? 'rgb(145, 158, 171)' : ''
                                    }}
                                >
                                    {t.title}
                                </span>
                            </Checkbox>
                        ))}
                        </Stack>
                    </Box>
                </Box>
            )} 
        />            
    )
}